import { LOGOUT } from "@/components/access/ducks/Actions"
import { ADMIN_RECEIVE_CONSTITUENT_SUBSCRIPTIONS } from "@/components/privacy/admin/ducks/Actions"
import { CLEAR_SELECTED_USER } from "@/components/search/ducks/Actions"

const defaultState = {
  selectedUserSubscriptions: null,
}

const adminPrivacyReducer = (oldState = defaultState, action) => {
  Object.freeze(oldState)
  switch (action.type) {
    case LOGOUT:
      return defaultState

    case ADMIN_RECEIVE_CONSTITUENT_SUBSCRIPTIONS:
      return {
        ...oldState,
        selectedUserSubscriptions: action.subscriptions,
      }

    case CLEAR_SELECTED_USER:
      return {
        ...oldState,
        selectedUserSubscriptions: null,
      }

    default:
      return oldState
  }
}

export default adminPrivacyReducer
